import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import { Link, useLocation, useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { GetUserListColumns } from "../../helpers/users/FetchSentimentList";
import { checkPermissionStatus } from "helpers/utils";
import arrow from "../../assets/images/icon/arrow.svg";
import close_icon from "../../assets/images/icon/close-icon.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import copy_icon from "../../assets/images/icon/copy.svg";

import ReactPlayer from "react-player";
import { decryptDataFromArray } from "../../helpers/EncDec";
import Jobs from "helpers/users/Jobs";

function SenitimentList(props) {
  const [query, setQuery] = useState("");
  const [videoUrl, setVideoUrl] = useState();
  let columns = GetUserListColumns(setVideoUrl);
  // let { userList: users, isLoading, error } = FecthSentimentList();
  const [users, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [linkCopied, SetLinkCopied] = useState(false);
  const pageHistory = useHistory();
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {from} to {to} of {size}
    </span>
  );

  const fetchSentimentList = async () => {
    try {
      api
        .get(
          `${process.env.REACT_APP_API_URL}/sentiment/admin/all-sentiments`
        )
        .then(res => {
          let response = decryptDataFromArray(res.data);
          let { userList, status } = response;
          if (status) {
            setUserList(userList);
          }

          setIsLoading(false);
        })
        .catch(err => {
          setError("No Data Available");
          console.log("err", err);
          setIsLoading(false);
        });
    } catch (error) {
      console.log("ERROR FROM CATCH", error);
    }
  };

  useEffect(() => {
    fetchSentimentList();
  }, []);

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  useEffect(() => {
    document.title = "NeuroTal - All Sentiments List";
  }, []);

 
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const renderCheck = item => {
    let searchableText = JSON.stringify(item)?.toLowerCase();
    if (searchableText?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const location = useLocation();
  // const showVideo = location?.state?.showVideo || false;

  // Function to close the video popup
  const closeVideoPopup = () => {
    setVideoUrl("");
  };
  const copyUrl = async () => {
    const subdomain = localStorage.getItem("subdomain");
    let link = `${process.env.REACT_APP_FRONTEND_URL}/sentiment`;
    link = link?.replace("//", `//${subdomain}.`);
    const unsecuredCopyToClipboard = text => {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy to clipboard", err);
      }
      document.body.removeChild(textArea);
    };

    if (window?.isSecureContext && navigator?.clipboard) {
      SetLinkCopied(true);
      setInterval(() => {
        SetLinkCopied(false);
      }, 1000);
      await navigator?.clipboard?.writeText(link);
    } else {
      SetLinkCopied(true);
      setInterval(() => {
        SetLinkCopied(false);
      }, 1000);
      unsecuredCopyToClipboard(link);
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
   if (!checkPermissionStatus("video-sentiment", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <>
      <div className="outerTab-box-wrapper applicationcard-table mobile-cards-view allapp-cation">
        <div className="page-content">
          <Container fluid>
            <div className="table-data-search copy-sentimentp7">
              <h5 className="text-uppercase heading-one mb-0 pt-0">
                Video Recording List
              </h5>
            </div>

            <Row>
              <div>
                {error === null ? (
                  users.length > 0 ? (
                    <>
                      <div className="franchise-list-page sentiment-cards-pr">
                        <div className="tab-content" id="pills-tabContent">
                          <div
                            className="tab-pane fade show active"
                            id="pills-home"
                            role="tabpanel"
                            // aria-labelledby="pills-home-tab"
                          >
                            <div className="tabel-franchise table-responsive">
                              <div className="tabel-application table-responsive">
                                <div className="table-data-search">
                                  <div className="total-record">
                                    <h5>
                                      Total Records:{" "}
                                      <span>{users?.length || 0}</span>
                                    </h5>
                                  </div>
                                  <div className="total-serachbar">
                                    <div className="serach-bar-top">
                                      <form className="form-inline">
                                        <input
                                          className="form-control mr-sm-2"
                                          type="search"
                                          placeholder="Search by Full Name, Email.."
                                          aria-label="Search"
                                          onChange={e =>
                                            setQuery(e.target.value)
                                          }
                                          title="Search by Full Name, Email.."
                                        />
                                        <span>
                                          <img src={serach_icon} alt="search" />
                                        </span>
                                      </form>
                                    </div>
                                    <div className="copy-sentiment-action">
                                      <Link
                                        className="text-success blue-icon heading-one action-one copy-sentiment w-100 text-end"
                                        to="#"
                                        onClick={copyUrl}
                                      >
                                        <img src={copy_icon} alt="copy icon" />
                                        Video Form Link
                                      </Link>
                                      {linkCopied && (
                                        <span className="heading-five blueco m-0 ">
                                          Link Copied To the clipboard
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row sentiment-cards">
                                  <Col lg="12" md="12">
                                    <div className="sentiment-heading-cards">
                                      <div className="d-flex align-items-center gap-1 sentiment-heading flex-wrap">
                                        <h4 className="text heading-four m-0">
                                          <b>Note :</b> Sentiments Analysis
                                          based on sentiment recording reports
                                          (Confidence Confused Unsure) &nbsp;
                                          <span
                                            className="heading-four blueco m-0 "
                                            onClick={() => {
                                              togglePopup();
                                            }}
                                          >
                                            More Sentiment can be configured,
                                            Know More
                                            <img src={arrow} alt="" />
                                          </span>
                                        </h4>
                                      </div>
                                      {isOpen && (
                                        <div className="sentiment-modal">
                                          <p>
                                            Nervousness, Professionalism,
                                            Curiosity, Positivity and Negativity
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col lg={3} col={12}>
                                    <div className="d-flex gap-1 blue-icon-gap last-icon flex-wrap justify-content-end d-none">
                                      <span
                                        style={{ color: "#87CEEB" }}
                                        className="mdi mdi-circle-box "
                                      >
                                        Confidence
                                      </span>
                                      <span
                                        style={{ color: "#F4A460" }}
                                        className="mdi mdi-circle-box "
                                      >
                                        Confused
                                      </span>
                                      <span
                                        style={{ color: "#FF69B4" }}
                                        className="mdi mdi-circle-box "
                                      >
                                        Unsure
                                      </span>
                                    </div>
                                  </Col>
                                </div>

                                <div className="more-childere-color">
                                  <ul>
                                    <li>Transcript Based Analysis</li>
                                    <li>Expression Based Analysis</li>
                                    <li>Tonality Based Analysis</li>
                                    <li>Score</li>
                                  </ul>
                                </div>

                                <div className="timeto-hire-card userlist pendiglist-cardss">
                                  <div className="table-custome-class range-custome">
                                    <div className="scroll-container">
                                      <div className="table-wrapper">
                                        <BootstrapTable
                                          keyField="id"
                                          data={users?.filter(renderCheck)}
                                          columns={columns}
                                          pagination={paginationFactory(
                                            options
                                          )}
                                          rowClasses={rowClasses}
                                          hover
                                          responsive
                                        />
                                        {/* <Jobs /> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        color: "#888",
                        fontWeight: "normal",
                        fontSize: "18px",
                      }}
                    >
                      No Data Available
                    </p>
                  )
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      color: "#888",
                      fontWeight: "normal",
                      fontSize: "18px",
                    }}
                  >
                    {error}
                  </p>
                )}
              </div>

              {videoUrl && (
                <>
                  <div className="video-popup">
                    <button className="close-button" onClick={closeVideoPopup}>
                      <img src={close_icon} alt="" />
                    </button>
                    <div className="video-container">
                      <ReactPlayer
                        url={videoUrl}
                        width="100%"
                        height="500px"
                        playing
                        // playIcon={<button>Play</button>}
                        controls={true} // Show native player controls
                        //light="https://i.stack.imgur.com/zw9Iz.png"
                      />{" "}
                    </div>
                  </div>
                  <div class="shadow-back"></div>
                </>
              )}
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default SenitimentList;
